import { createSlice } from "@reduxjs/toolkit";

const initialState = {};
const QuestionaireReducer = createSlice({
  name: "Questionaire",
  initialState,
  reducers: {
    defaultAction: (state, { payload }) => {
      console.log("QuestionaireReducer state and payload", state, payload);
    },
  },
});

const { reducer, actions } = QuestionaireReducer;
export const { defaultAction } = actions;
export default reducer;
